










































































































































































































import {
  Mixins, Component, Prop,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import AuthModule from '@/store/modules/Auth';
import utils from '@/services/utils';

@Component
export default class MemberBody extends Mixins(
  ErrorHandleMixin,
) {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data: any;

  @Prop() readonly isHide: any;

  @Prop() readonly summary: any;

  @Prop() readonly multiCurrency: any

  @Prop() readonly fetchWinloseAgent!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly mainRole!: string;

  utilsInstance = utils;

  handleSub(user) {
    this.fetchWinloseAgent(user.username, user.role, user.source, user.id);
  }
}
